<template>
  <div class="h-full w-full flex flex-col justify-center">
    <div
      class="bg-white rounded-xl overflow-auto w-full p-4"
      :style="{
        maxHeight: '90vh'
      }"
    >
      <slot />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MessageDialog',
});
</script>
